

import Vue from 'vue'
import FastClick from 'fastclick'
import App from './App'
import router from './router/index'
import store from './vuex/store'
import '@/common/index.less'
import axios from 'axios'
import Video from 'video.js'
import 'video.js/dist/video-js.css'
import moveVideo from 'move-video'





import ToastPlugin from 'vux/src/plugins/toast/index.js'

Vue.use(ToastPlugin)

import LoadingPlugin from 'vux/src/plugins/loading/index.js'

Vue.use(LoadingPlugin)

import ConfirmPlugin from 'vux/src/plugins/confirm/index.js'

Vue.use(ConfirmPlugin)

import VueAwesomeSwiper from 'vue-awesome-swiper'
Vue.use(VueAwesomeSwiper)
Vue.use(VueLazyload, {
preLoad: 1.3,


attempt: 1
})

import Tab from 'vux/src/components/tab/tab.vue'
import TabItem from 'vux/src/components/tab/tab-item.vue'
import Search from 'vux/src/components/search/index.vue'
import Swiper from 'vux/src/components/swiper/swiper.vue'
import Group from 'vux/src/components/group/index.vue'
import XTextarea from 'vux/src/components/x-textarea/index.vue'
import XAddress from 'vux/src/components/x-address/index.vue'
import ChinaAddressV4Data from 'vux/src/datas/china_address_v4.json'
import Calendar from 'vux/src/components/calendar/index.vue'
import Checker from 'vux/src/components/checker/checker.vue'
import CheckerItem from 'vux/src/components/checker/checker-item.vue'
import Popup from 'vux/src/components/popup/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import LoadMore from 'vux/src/components/load-more/index.vue'
import Confirm from 'vux/src/components/confirm/index.vue'
import Range from 'vux/src/components/range/index.vue'



Vue.component('tab', Tab)
Vue.component('tab-item', TabItem)
Vue.component('search', Search)
Vue.component('swiper', Swiper)
Vue.component('x-textarea', XTextarea)
Vue.component('group', Group)
Vue.component('x-address', XAddress)
Vue.component('calendar', Calendar)
Vue.component('checker', Checker)
Vue.component('checker-item', CheckerItem)
Vue.component('popup', Popup)
Vue.component('cell', Cell)
Vue.component('load-more', LoadMore)
Vue.component('confirm', Confirm)
Vue.component('range', Range)
Vue.component('moveVideo', moveVideo)


FastClick.attach(document.body)

Vue.config.productionTip = false

Vue.prototype.$bus = new Vue()
Vue.prototype.$video = Video
/* eslint-disable no-new */
new Vue({
router,
store,
render: h => h(App)
}).$mount('#app-box')



// WEBPACK FOOTER //
// ./src/main.js